import _ from 'lodash';

export const getFAQIndex = (keys, prevKeys) =>
	Array.isArray(keys) ? _.difference(keys, prevKeys)[0] : keys;
